import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsExpressComponent } from './simple-icons-express.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsExpressComponent ],
    exports:      [ SimpleIconsExpressComponent ],
    bootstrap:    []
})
export class SimpleIconsExpressModule {}
